import { PayrollCycleFrequencyEnum, PayrollCycleStateTypeEnum } from "@oysterhr/schema"
import { BadgeStateItem } from "~/shared/components/StatesDescription"

export const PayrollCycleFrequencyLabelsMap: Record<
  PayrollCycleFrequencyEnum,
  Pick<BadgeStateItem, "translationKey">
> = {
  [PayrollCycleFrequencyEnum.Monthly]: {
    translationKey: "payrollCycleFrequency.monthly",
  },
  [PayrollCycleFrequencyEnum.SemiMonthly]: {
    translationKey: "payrollCycleFrequency.semimonthly",
  },
  [PayrollCycleFrequencyEnum.BiWeekly]: {
    translationKey: "payrollCycleFrequency.biweekly",
  },
}

export const PayrollCycleStates = [
  PayrollCycleStateTypeEnum.Draft,
  PayrollCycleStateTypeEnum.Processing,
  PayrollCycleStateTypeEnum.AwaitingApproval,
  PayrollCycleStateTypeEnum.Approved,
  PayrollCycleStateTypeEnum.ReadyForPayments,
  PayrollCycleStateTypeEnum.Completed,
]

export const PayrollCycleMainStateLabelsMap: Record<
  PayrollCycleStateTypeEnum,
  BadgeStateItem & { order: number }
> = {
  [PayrollCycleStateTypeEnum.Draft]: {
    order: 1,
    variation: "gray",
    translationKey: "mainState.draft.title",
    descriptionKey: "mainState.draft.description",
  },
  [PayrollCycleStateTypeEnum.GeneratePir]: {
    order: 2,
    variation: "info",
    translationKey: "mainState.generatePir.title",
    descriptionKey: "mainState.generatePir.description",
  },
  [PayrollCycleStateTypeEnum.Processing]: {
    order: 3,
    variation: "info",
    translationKey: "mainState.processingPayroll.title",
    descriptionKey: "mainState.processingPayroll.description",
  },
  [PayrollCycleStateTypeEnum.AwaitingApproval]: {
    order: 4,
    variation: "warning",
    translationKey: "mainState.awaitingApproval.title",
    descriptionKey: "mainState.awaitingApproval.description",
  },
  [PayrollCycleStateTypeEnum.Approved]: {
    order: 5,
    variation: "info",
    translationKey: "mainState.approved.title",
    descriptionKey: "mainState.approved.description",
  },
  [PayrollCycleStateTypeEnum.ReadyForPayments]: {
    order: 6,
    variation: "info",
    translationKey: "mainState.readyForPayments.title",
    descriptionKey: "mainState.readyForPayments.description",
  },
  [PayrollCycleStateTypeEnum.Completed]: {
    order: 7,
    variation: "success",
    translationKey: "mainState.payrollProcessed.title",
    descriptionKey: "mainState.payrollProcessed.description",
  },
  [PayrollCycleStateTypeEnum.ChangesRequested]: {
    order: 8,
    variation: "warning",
    translationKey: "mainState.changesRequested.title",
    descriptionKey: "mainState.changesRequested.description",
  },
}

export const DOCUMENT_MIME_TYPES = [
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xls
].join(",")

export const DOCUMENT_FUNDING_MIME_TYPES = [
  "text/csv",
  "text/plain",
  "application/xml",
  "application/pdf",
].join(",")

export const DOCUMENT_BANK_PAYMENT_MIME_TYPES = ["text/csv", "text/plain", "application/xml"].join(
  ",",
)

export const DOCUMENT_GL_REPORT_MIME_TYPES = [
  "text/csv",
  "application/xml",
  "application/octet-stream",
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xls
].join(",")
